$(document).ready(function() {
if ($(window).width() > 767) {
  $(function() {
    $('.our_location_main .height-cust .our_location_item  .address-bar').matchHeight(
      {
        byRow: true,
        property: 'height',
      }
    );
    $('.our_location_main .height-cust .our_location_item  .our_location_content').matchHeight(
      {
        byRow: true,
        property: 'height',
      }
    );
  });
}
  if ($(window).width() < 768) {
  $(function() {
     $('.tag-list li a').on('click', function() {
    $(this).parent().parent().slideUp();
  });
  });
}
$('.blog-sidebar h2.mobile').on('click', function() {
    $(this).next().slideToggle();
  $(this).parent().addClass('opened');
  $(this).parent().siblings().find("h2.mobile").next().slideUp();
  $(this).parent().siblings().removeClass('opened');
  });
 
  	
$('video').click(function(){
	// Toggle Magic Here
    this[this.paused ? 'play' : 'pause']();
});


// equal heights ---------- 
/*jQuery('.our_location_main').each(function(){  
      
      // Cache the highest
      var highestBox = 0;
      
      // Select and loop the elements you want to equalise
      jQuery('.address-bar', this).each(function(){
        
        // If this box is higher than the cached highest then store it
        if(jQuery(this).height() > highestBox) {
          highestBox = jQuery(this).height(); 
        }
      
      });  
            
      // Set the height of all those children to whichever was highest 
      jQuery('.address-bar',this).height(highestBox);
                    
    }); */
//  END equal heights ---------------------------------





  
    
       $window = $(window);
$slick_slider = $('.featured-collection-main .product-grid');
settings = {
  arrows: false,
  dots: true,
  slidesToShow: 3,
  centerMode: true,
  autoplay: true,
    autoplaySpeed: 3000,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick"
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
  ],
};
$slick_slider.slick(settings);
  

 
$window.on('resize', function() {
  if ($window.width() > 1024) {
    if ($slick_slider.hasClass('slick-initialized'))
      $slick_slider.slick('unslick');
    return
  }
  if ( ! $slick_slider.hasClass('slick-initialized'))
    return $slick_slider.slick(settings);

   if ($(window).width() < 768) {
  $(function() {
     $('.tag-list li a').on('click', function() {
    $(this).parent().parent().slideUp();
  });
  });
}
});  


  $home_slick_slider = $('#home-slider');
settings = {
  draggable: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: true,
    fade: true,
    speed: 2500,
    infinite: true
};
$home_slick_slider.slick(settings);

   // $(".product-recommendations").bind("DOMSubtreeModified", function() {
    $related_slick_slider = $('.product-recommendations .related-slider');
settings = {
  arrows: false,
  dots: true,
  autoplay: true,
    autoplaySpeed: 3000,
  slidesToShow: 3,
  centerMode: true,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick"
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
  ],
};
$related_slick_slider.slick(settings);

$window.on('resize', function() {
  if ($window.width() > 1024) {
    if ($related_slick_slider.hasClass('slick-initialized'))
      $related_slick_slider.slick('unslick');
    return
  }
  if ( ! $related_slick_slider.hasClass('slick-initialized'))
    return $related_slick_slider.slick(settings);
});
// });


  $('.ukraine-gallery').isotope({
  itemSelector: '.item',
  masonry: {
    columnWidth: 100,
    gutter: 6
  }
});



  
  $('.tidbits-mobile-top').isotope({
  itemSelector: '.top',
      percentPosition: true, 
    layoutMode: 'fitRows',
      masonry: {
        columnWidth: '.grid-sizer',
        gutter: 6
      }
  });

    $('.tidbits-mobile-bottom').isotope({
  itemSelector: '.bottom',
      percentPosition: true,
    layoutMode: 'fitRows',
      masonry: {        
        columnWidth: '.grid-sizer',
        gutter: 6
      }
});
  
  $('.about-image').isotope({
  itemSelector: '.item',
  masonry: {
    columnWidth: 100,
    gutter: 6
  }
});

  $('.about-mobile-top').isotope({
  itemSelector: '.top',
      percentPosition: true,
    layoutMode: 'fitRows',
      masonry: {
          gutter: 6
      }
});
  $('.about-mobile-bottom').isotope({
  itemSelector: '.bottom',
      percentPosition: true,
    layoutMode: 'fitRows',
      masonry: {
          gutter: 6
      }
});

$('.available-after-main').isotope({
  itemSelector: '.available-after-item'
});


 // $(".moreless-button").click(function() {
 //    var elem = $(".moreless-button").text();
 //    if (elem == "Read More") {
 //      //Stuff to do when btn is in the read more state
 //      $(".moreless-button").text("Read Less");
 //      $("#more-text").slideDown();
 //    } else {
 //      //Stuff to do when btn is in the read less state
 //      $(".moreless-button").text("Read More");
 //      $("#more-text").slideUp();
 //    }
 //  });

  // code for add read more/ less button on about page
  var divheight = $(".about-content .producttext").height();
  var lineheight = parseInt($(".about-content .producttext").children().css('line-height'), 10);
  var linecount = Math.round(divheight / lineheight);
  if(linecount > 12) {
    if($('.about-content .moreless-button').hasClass('hidden')) {
      $('.about-content .moreless-button').removeClass('hidden');
    }
  }

  jQuery(document).on('click', '.moreless-button', function(){
  var producttext = jQuery(this).closest('.about-cnt').find('.producttext');
    // console.log(producttext)
  if(producttext.hasClass('read-more')) {
    producttext.removeClass('read-more');
    jQuery(this).text('Read More');
  } else {
    producttext.addClass('read-more');
    jQuery(this).text('Read Less');
  }
});


  // code for add read more/ less button on team section
  var divheight_team = $(".about_team_wrap  .teamtext").height();
  var lineheight_team = parseInt($(".about_team_wrap  .teamtext").children().css('line-height'), 10);
  var linecount_team = Math.round(divheight_team / lineheight_team);
  if(linecount_team > 12) {
    if($('.about_team_wrap  .moreless-button-d').hasClass('hidden')) {
      $('.about_team_wrap  .moreless-button-d').removeClass('hidden');
    }
  }

  jQuery(document).on('click', '.moreless-button-d', function(){
  var teamtext = jQuery(this).closest('.about_team_content').find('.teamtext');
    // console.log(teamtext)
  if(teamtext.hasClass('read-more-team')) {
    teamtext.removeClass('read-more-team');
    jQuery(this).text('Read More!');
  } else {
    teamtext.addClass('read-more-team');
    jQuery(this).text('Read Less');
  }
});










  



  

$('.related-slider').slick({
 
  infinite: true,
  arrows: false,
  autoplay:true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
   dots: $(".related-slider li").length > 4 ? true: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: $(".related-slider li").length > 3 ? true: false
      }
    },
       {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: $(".related-slider li").length > 2 ? true: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  
  ]
});


$('.history-slider ul').slick({
  infinite: false,
  arrows: true,
  dots: false,
  centerMode: false,
  centerPadding: '0px',
  // autoplay:true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  
  ]
});


 $('#shopify-section-announcement-bar').slick({
  infinite: true,
  arrows: false,
  dots: false,
  centerMode: false,
  centerPadding: '0px',
   speed: 1500,
   autoplay:true,
   autoplaySpeed: 5000,  
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  
  ]
}); 


  
});


jQuery(window).on('load', function(){
    jQuery('body').addClass('custom-set');
})


$( document ).ready(function() {

  // Play/Pause Video
  $(document).on("click", ".grid-video-img-cus .btn-play-pause, .grid-video-img-cus video", function(){
    // Pause all other video
    $(this).closest('.grid-video-img-cus').addClass('active');
    $.each($('.grid-video-img-cus'), function() {
      if(!$(this).hasClass('active')) {
        var btnActive = $(this).find('.btn-play-pause');
        if(btnActive.hasClass('active')) {
          $(this).find('video').get(0).pause();
          btnActive.removeClass('active');
        }
      }
    });

    // pause all iframe video
    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, iframe => {
      iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*');
    });
    $(this).closest('.grid-video-img-cus').removeClass('active');

    // Play clicked video
    var ctrlVideo = $(this).closest('.grid-video-img-cus').find('video');
    var ctrlButton = $(this).closest('.grid-video-img-cus').find('.btn-play-pause');
    if (ctrlButton.hasClass("active")){
      ctrlVideo.get(0).pause();
      ctrlButton.removeClass("active");
    } else {
      ctrlVideo.get(0).play();
      ctrlButton.addClass("active");
    }
  });

  // Play/Pause Video
  $(document).on("click", ".has-video-tag .btn-play-pause, .has-video-tag video", function(){
    var ctrlVideo = $(this).closest('.has-video-tag').find('video');
    var ctrlButton = $(this).closest('.has-video-tag').find('.btn-play-pause');
    if (ctrlButton.hasClass("active")){
      ctrlVideo.get(0).pause();
      ctrlButton.removeClass("active");
    } else {
      ctrlVideo.get(0).play();
      ctrlButton.addClass("active");
    }
  });

});

// press page video grid section
$(document).ready(function(){
  $('.template-page-press .video-press-section').each(function(key,value){
    var nextElement = $(this).parent().next().find('.video-press-section');
    if(nextElement.length > 0) {
      if($(nextElement).find('.page-width h3').html() == undefined) {
        $(this).css("margin-bottom","0");
      }
    }
  });
});